// Share-a-win: the growth loop. Uses the native share sheet on mobile,
// falls back to clipboard on desktop. Returns how it was delivered so the
// caller can show the right feedback.

export type ShareOutcome = 'shared' | 'copied' | 'failed'

export function winMessage(emoji: string, question: string, big: string | null): string {
  const url = window.location.origin
  const result = big ? ` My model answered: ${big}.` : ''
  return `${emoji} I just trained a real ML model to answer “${question}” — and beat the challenge.${result} Try it free, no signup: ${url}`
}

export async function shareWin(text: string): Promise<ShareOutcome> {
  if (navigator.share) {
    try {
      await navigator.share({ text })
      return 'shared'
    } catch {
      // user dismissed the sheet or share failed — fall through to clipboard
    }
  }
  try {
    await navigator.clipboard.writeText(text)
    return 'copied'
  } catch {
    return 'failed'
  }
}
